import { REDUX } from "../../constants";

export const setPageLoad = (page = false) => {
  return { type: REDUX.PAGE_LOAD,  page};
};